const $ = jQuery;

export default function () {
    const $triggers = $('.js-video-modal--trigger');

    if (!$triggers.length) return;

    const $modal = createModal();
    $('body').append($modal);
    const $videoContainer = $modal.find('.video-modal__video');
    const $videoElement = $modal.find('video')[0];
    const $iframeElement = $modal.find('iframe')[0];

    // Helper function to check if URL is YouTube embed URL
    const isYouTubeUrl = (url) => {
        return url && /youtube\.com\/embed\//.test(url);
    };

    $triggers.on('click', function (e) {
        e.preventDefault();
        const url = $(this).attr('href');

        if (isYouTubeUrl(url)) {
            // Use iframe for YouTube videos
            if ($iframeElement) {
                $iframeElement.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
                $iframeElement.style.display = 'block';
            }
            if ($videoElement) {
                $videoElement.style.display = 'none';
                $videoElement.src = '';
            }
        } else {
            // Use video element for regular video files
            if ($videoElement) {
                $videoElement.src = url;
                $videoElement.load();
                $videoElement.play().catch((error) => {
                    console.warn('Video autoplay failed:', error);
                });
                $videoElement.style.display = 'block';
            }
            if ($iframeElement) {
                $iframeElement.src = '';
                $iframeElement.style.display = 'none';
            }
        }
        $modal.removeClass('is-hidden');
        $('body').addClass('body--modal-open');
    });

    $(document).on('click', '.video-modal__overlay', function (e) {
        e.preventDefault();
        $modal.addClass('is-hidden');
        if ($videoElement) {
            $videoElement.pause();
            $videoElement.src = '';
        }
        if ($iframeElement) {
            $iframeElement.src = '';
        }
        $('body').removeClass('body--modal-open');
    });

    console.log('Video modal initialized');
}

function createModal() {
    const $modal = $('<div class="video-modal is-hidden"></div>');

    $modal.html(`
        <div class="video-modal__overlay"></div>
        <div class="video-modal__content">
            <div class="video-modal__video">
                <video src="" controls playsinline autoplay style="display: none;"></video>
                <iframe src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="display: none; width: 100%; height: 100%;"></iframe>
            </div>
        </div>
    `);

    return $modal;
}
